import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import ExportLocationsAdmin from "@/components/export-locations-admin/ExportLocationsAdmin";
import NewChatButton from "@/components/layout/NewChatButton";

const AdminExportLocationsPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="Manage which destinations are available to users when exporting or transferring clips. Locations sync from Iconik and are disabled by default."
      actions={<NewChatButton />}
    >
      Export & Transfer Locations
    </Header>
    <ExportLocationsAdmin />
  </SpaceBetween>
);

export default AdminExportLocationsPage;
